/**
 * Statuts financiers — source de vérité canonique (frontend).
 * Doit rester aligné avec :
 *   backend/services/financial_workflow_service.py → FINANCIAL_STATUSES
 *   backend/routes/admin_operations_routes.py → ALLOWED_FINANCIAL_STATUSES
 *
 * Ordre du workflow :
 *   pending → quote_sent → quote_accepted → invoiced
 *          → pending_payment → partially_paid → paid
 */

export const FINANCIAL_STATUS_CONFIG = {
  pending:         { label: 'En attente',          bg: 'bg-gray-100',    text: 'text-gray-700',    dot: 'bg-gray-400' },
  quote_sent:      { label: 'Devis envoyé',        bg: 'bg-blue-50',     text: 'text-blue-700',    dot: 'bg-blue-500' },
  quote_accepted:  { label: 'Devis accepté',       bg: 'bg-emerald-50',  text: 'text-emerald-700', dot: 'bg-emerald-500' },
  invoiced:        { label: 'Facturée',            bg: 'bg-purple-50',   text: 'text-purple-700',  dot: 'bg-purple-500' },
  pending_payment: { label: 'En attente paiement', bg: 'bg-orange-50',   text: 'text-orange-700',  dot: 'bg-orange-500' },
  partially_paid:  { label: 'Paiement partiel',    bg: 'bg-amber-50',    text: 'text-amber-700',   dot: 'bg-amber-500' },
  paid:            { label: 'Payée',               bg: 'bg-green-50',    text: 'text-green-700',   dot: 'bg-green-500' },
  // Pseudo-statut UI uniquement : opérations sans financialStatus persisté
  no_status:       { label: 'Sans statut',         bg: 'bg-rose-50',     text: 'text-rose-700',    dot: 'bg-rose-400' },
  // Statuts terminaux / exceptionnels (non dans le workflow principal mais rencontrés en base)
  quote_rejected:  { label: 'Devis refusé',        bg: 'bg-red-50',      text: 'text-red-700',     dot: 'bg-red-500' },
  quote_expired:   { label: 'Devis expiré',        bg: 'bg-stone-100',   text: 'text-stone-600',   dot: 'bg-stone-400' },
  cancelled:       { label: 'Annulée',             bg: 'bg-slate-100',   text: 'text-slate-600',   dot: 'bg-slate-400' },
  refunded:        { label: 'Remboursée',          bg: 'bg-cyan-50',     text: 'text-cyan-700',    dot: 'bg-cyan-500' },
};

/** Ordre officiel du workflow (à utiliser pour dropdowns & timelines). */
export const FINANCIAL_STATUS_WORKFLOW = [
  'pending',
  'quote_sent',
  'quote_accepted',
  'invoiced',
  'pending_payment',
  'partially_paid',
  'paid',
];

/** Statuts acceptés côté API qualify-financial-status. */
export const ALLOWED_QUALIFY_STATUSES = FINANCIAL_STATUS_WORKFLOW;

/** Helper : renvoie le libellé humain ou la valeur brute en fallback. */
export const getFinancialStatusLabel = (status) =>
  FINANCIAL_STATUS_CONFIG[status]?.label || status || '—';
